import ru from './ru.json';
import en from './en.json';

type Dict = Record<string, string>;
const DICTS: Record<string, Dict> = { ru, en };
let current: Dict = ru;

export async function loadLocale(lang: 'ru' | 'en') {
  current = DICTS[lang] ?? ru;
}

export function t(key: string): string {
  return current[key] ?? key;
}
